export enum PaymentSources {
  Payu = 1,
  Offline = 2,
  Paytm = 3,
  CCAvenue = 6,
  Razorpay = 7
}
